// Fields whose value is a complex structure (object/array) — shown as a
// simple "changed" flag instead of a deep diff, per spec 55 (Tarefa 6b).
const COMPLEX_FIELDS = new Set([
  'business_hours',
  'company_business_hours',
  'response_guidelines',
  'guardrails',
]);

const FIELD_LABEL_KEYS = {
  product_name: 'CAPTAIN.ASSISTANTS.FORM.PRODUCT_NAME.LABEL',
  company_description: 'CAPTAIN.ASSISTANTS.FORM.COMPANY_DESCRIPTION.LABEL',
  timezone: 'CAPTAIN.ASSISTANTS.FORM.TIMEZONE.LABEL',
  business_hours: 'CAPTAIN.ASSISTANTS.FORM.BUSINESS_HOURS.LABEL',
  company_business_hours: 'CAPTAIN.ASSISTANTS.FORM.BUSINESS_HOURS.LABEL',
  agent_role: 'CAPTAIN.ASSISTANTS.FORM.AGENT_ROLE.LABEL',
  tone: 'CAPTAIN.ASSISTANTS.FORM.TONE.LABEL',
  script: 'CAPTAIN.ASSISTANTS.FORM.SCRIPT.LABEL',
  default_language: 'CAPTAIN.ASSISTANTS.FORM.DEFAULT_LANGUAGE.LABEL',
  detect_language: 'CAPTAIN.ASSISTANTS.FORM.LOCK_TO_DEFAULT_LANGUAGE.LABEL',
  welcome_message: 'CAPTAIN.ASSISTANTS.FORM.WELCOME_MESSAGE.LABEL',
  response_guidelines: 'CAPTAIN.ASSISTANTS.FORM.FEATURES.TITLE',
  guardrails: 'CAPTAIN.ASSISTANTS.FORM.FEATURES.TITLE',
};

export const fieldLabelKey = field => FIELD_LABEL_KEYS[field] || null;

export const isComplexField = field => COMPLEX_FIELDS.has(field);

/**
 * Compares two config snapshots (jsonb hashes) and returns the list of
 * fields that changed, each as { field, from, to }. Fields present in only
 * one side are included with the missing side as undefined. Identical
 * fields are skipped.
 */
export const buildConfigDiff = (fromSnapshot = {}, toSnapshot = {}) => {
  const fields = new Set([
    ...Object.keys(fromSnapshot || {}),
    ...Object.keys(toSnapshot || {}),
  ]);

  const changes = [];
  fields.forEach(field => {
    const from = fromSnapshot?.[field];
    const to = toSnapshot?.[field];
    if (JSON.stringify(from) === JSON.stringify(to)) return;

    changes.push({ field, from, to });
  });

  return changes;
};
